"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var styles_1 = require("@mui/material/styles");
var Button_1 = __importDefault(require("atomicComponents/atoms/Buttons/Button"));
var LineButton_1 = __importDefault(require("atomicComponents/atoms/Buttons/LineButton"));
var analytics_1 = require("utils/analytics");
var PREFIX = 'SubmitPopup';
var classes = {
    paper: "".concat(PREFIX, "-paper"),
};
var StyledSlide = (0, styles_1.styled)(material_1.Slide)(function (_a) {
    var theme = _a.theme;
    return ({
        zIndex: 1,
        position: 'absolute',
        bottom: theme.spacing(4),
        width: '100%',
        borderTop: "1px solid ".concat(theme.palette.secondary.main),
        borderRadius: '0',
        paddingTop: theme.spacing(3),
        '& button[type=submit]': {
            marginRight: theme.spacing(3),
        },
        boxShadow: 'none',
    });
});
var SubmitPopup = function (_a) {
    var isOpen = _a.isOpen, onSave = _a.onSave, onCancel = _a.onCancel, formError = _a.formError, context = _a.context;
    var trackFormInteraction = (0, analytics_1.usePreparedTracker)('Form Interaction');
    return ((0, jsx_runtime_1.jsx)(StyledSlide, __assign({ direction: "up", in: isOpen }, { children: (0, jsx_runtime_1.jsxs)(material_1.Paper, __assign({ elevation: 4, className: classes.paper }, { children: [(0, jsx_runtime_1.jsx)(Button_1.default, __assign({ type: "submit", disabled: !isOpen || formError, onClick: function () {
                        trackFormInteraction({ action: 'Saved', context: context });
                        onSave();
                    } }, { children: "Save changes" })), (0, jsx_runtime_1.jsx)(LineButton_1.default, __assign({ disabled: !isOpen, onClick: function () {
                        trackFormInteraction({ action: 'Cancelled', context: context });
                        onCancel();
                    } }, { children: "Cancel" }))] })) })));
};
exports.default = SubmitPopup;
